module.exports = __webpack_public_path__ + "img/346.dad3d2f5.jpg";